import './password-input.scss';

import PasswordInput from './PasswordInput';

export default PasswordInput;
